jQuery(document).on("swup:pageView", function () {
  $ = jQuery;

  var isMobile = window.matchMedia("only screen and (max-width: 949px)").matches;

  $('a[href*="#"]').click(function (event) {
    // Prevent default anchor click behavior
    event.preventDefault();

    // Store hash
    var hash = this.hash;

    // Using jQuery's animate() method to add smooth page scroll
    // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
    $("html, body").animate(
      {
        scrollTop: $(hash).offset().top,
      },
      800,
      function () {
        // Do not add hash to URL when done scrolling (default click behavior)
      }
    );
  });

  if ($(".home-hero").length) {
    /****************************
     * Home Hero Slider
     *********************/
    var $homeSlider = $(".home-hero .owl-carousel");
    $homeSlider.owlCarousel({
      autoplay: true,
      stagePadding: 0,
      loop: true,
      rewind: false,
      nav: false,
      items: 1,
      singleItem: true,
      margin: 24,
      dots: false,
      autoHeight: false,
      smartSpeed: 600,
      checkVisibility: true,
      responsive: {
        0: {
          stagePadding: 0,
          margin: 0,
        },
        768: {
          stagePadding: 25,
          margin: 24,
        },
        950: {
          stagePadding: 100,
        },
        1200: {
          stagePadding: 150,
        },
        1500: {
          stagePadding: 200,
        },
        2000: {
          stagePadding: 300,
        },
      },
    });

    $homeSlider.on("changed.owl.carousel", function (event) {
      $(this).trigger("stop.owl.autoplay"); // resets the autoplay when
      $(this).trigger("play.owl.autoplay"); // user performs any actions
    });

    $(window).on("resize", function () {
      $(".home-hero .owl-carousel .owl-stage-outer").width(innerWidth);
    });
  }

  if ($(".key-hires-section").length) {
    /****************************
     * Home Hires Slider
     *********************/
    var $homeHireSlider = $(".key-hires-section .owl-carousel");

    // $homeHireSlider.on("initialized.owl.carousel", function (e) {
    //   console.log(e.item.count);
    // });

    var itemCount;

    $homeHireSlider
      .on("initialized.owl.carousel", function (e) {
        itemCount = e.item.count;

        if (itemCount < 4) {
          $(this).addClass("no-mouse-drag");
        }
      })
      .owlCarousel({
        autoplay: false,
        stagePadding: 0,
        loop: false,
        rewind: true,
        nav: false,
        items: 3,
        singleItem: true,
        margin: 24,
        dots: false,
        autoHeight: false,
        smartSpeed: 600,
        checkVisibility: true,
        mouseDrag: itemCount > 3 ? true : false,
        responsive: {
          0: {
            items: 1,
            autoplay: true,
            nav: true,
            navText: [
              '<svg viewBox="0 0 15 27" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14 25.6357L2 13.6357L14 1.63574" stroke="black" stroke-width="2"/></svg>',
              '<svg viewBox="0 0 15 27" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14 25.6357L2 13.6357L14 1.63574" stroke="black" stroke-width="2"/></svg>',
            ],
            // stagePadding: 0,
          },
          768: {
            nav: false,
            autoplay: false,
            items: 3,
            // stagePadding: 25,
          },
          950: {
            // items: 3,
            // autoplay: false,
            // stagePadding: 100,
          },
          // 1200: {
          //   stagePadding: 150,
          // },
          // 1500: {
          //   stagePadding: 200,
          // },
          // 2000: {
          //   stagePadding: 300,
          // },
        },
      });

    $homeHireSlider.on("changed.owl.carousel", function (event) {
      $(this).trigger("stop.owl.autoplay"); // resets the autoplay when
      $(this).trigger("play.owl.autoplay"); // user performs any actions
    });

    $(window).on("resize", function () {
      $(".key-hires-section .owl-carousel .owl-stage-outer").width(innerWidth);
    });
  }

  if ($(".home-profile-carousel").length) {
    var $homeProfileSlider = $(".home-profile-carousel .owl-carousel");
    $homeProfileSlider.owlCarousel({
      autoplay: true,
      stagePadding: 0,
      loop: true,
      rewind: false,
      nav: true,
      navText: [
        '<svg viewBox="0 0 15 27" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14 25.6357L2 13.6357L14 1.63574" stroke="black" stroke-width="2"/></svg>',
        '<svg viewBox="0 0 15 27" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14 25.6357L2 13.6357L14 1.63574" stroke="black" stroke-width="2"/></svg>',
      ],
      items: 2,
      singleItem: true,
      margin: 16,
      dots: false,
      autoHeight: false,
      smartSpeed: 600,
      checkVisibility: true,
      responsive: {
        0: {
          stagePadding: 0,
          margin: 0,
          items: 1,
        },
        768: {
          stagePadding: 25,
          items: 2,
        },
        950: {
          stagePadding: 50,
        },
        1200: {
          stagePadding: 100,
        },
        // 1500: {
        //   stagePadding: 150,
        // },
        2000: {
          stagePadding: 150,
        },
      },
    });

    $homeProfileSlider.on("changed.owl.carousel", function (event) {
      $(this).trigger("stop.owl.autoplay"); // resets the autoplay when
      $(this).trigger("play.owl.autoplay"); // user performs any actions
    });

    $(window).on("resize", function () {
      $(".home-profile-carousel .owl-carousel .owl-stage-outer").width(innerWidth);
    });
  }

  if ($(".home-faq-section").length) {
    $(".faq-question").on("click", function () {
      $(this).parent().toggleClass("active");
      $(this).next(".faq-answer").slideToggle();
    });
  }

  if ($(".home-testimonials").length) {
    /****************************
     * Home home-testimonials Slider
     *********************/
    var $homeTestimonialSlider = $(".home-testimonials .owl-carousel");

    // $homeHireSlider.on("initialized.owl.carousel", function (e) {
    //   console.log(e.item.count);
    // });

    var itemCountTestimonial;

    $homeTestimonialSlider
      .on("initialized.owl.carousel", function (e) {
        itemCountTestimonial = e.item.count;

        if (itemCountTestimonial < 4) {
          $(this).addClass("no-mouse-drag");
        }
      })
      .owlCarousel({
        autoplay: true,
        stagePadding: 0,
        loop: false,
        rewind: true,
        nav: false,
        items: 3,
        singleItem: true,
        margin: 0,
        dots: false,
        autoHeight: false,
        smartSpeed: 600,
        checkVisibility: true,
        mouseDrag: true,
        responsive: {
          0: {
            items: 1,
            autoplay: true,
            nav: true,
            navText: [
              '<svg viewBox="0 0 15 27" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14 25.6357L2 13.6357L14 1.63574" stroke="black" stroke-width="2"/></svg>',
              '<svg viewBox="0 0 15 27" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14 25.6357L2 13.6357L14 1.63574" stroke="black" stroke-width="2"/></svg>',
            ],
            // stagePadding: 0,
          },
          768: {
            nav: false,
            autoplay: true,
            items: 3,
            // stagePadding: 25,
          },
          950: {
            // items: 3,
            // autoplay: false,
            // stagePadding: 100,
          },
          // 1200: {
          //   stagePadding: 150,
          // },
          // 1500: {
          //   stagePadding: 200,
          // },
          // 2000: {
          //   stagePadding: 300,
          // },
        },
      });

    $homeHireSlider.on("changed.owl.carousel", function (event) {
      $(this).trigger("stop.owl.autoplay"); // resets the autoplay when
      $(this).trigger("play.owl.autoplay"); // user performs any actions
    });

    $(window).on("resize", function () {
      $(".home-testimonials .owl-carousel .owl-stage-outer").width(innerWidth);
    });
  }
});
